<agpr-dialog-container
    id="sharedReportCreateDialog"
    [heading]="sharedReport.id ? 'Reports.sharedReportEditDialog' : 'Reports.sharedReportSetupDialog.heading'"
    [modal]="true"
    [contentPadding]="false"
    (close)="closeDialog()"
>
    <agpr-scroll-panel>
        <div class="agpr-createSharedReport-content">
            <agpr-panel
                class="agpr-createSharedReport-settings"
                [header]="'Reports.sharedReportSetupDialog.reportSettings'"
            >
                <div class="agpr-createSharedReport-setup">
                    <div class="agpr-createSharedReport-form">
                        <agpr-panel
                            class="agpr-createSharedReport-form-title"
                            [header]="'Reports.sharedReportSetupDialog.report.name'"
                            [toggleable]="false"
                            [contentPadding]="false"
                            [paddingBottom]="0"
                        >
                            <div class="agpr-createSharedReport-form-input">
                                <agpr-text-input
                                    [maxLength]="64"
                                    [placeholder]="'Reports.sharedReportSetupDialog.report.name.placeholder'"
                                    [id]="'sharedReports.reportNameTextInput'"
                                    [(ngModel)]="sharedReport.name"
                                    (ngModelChange)="reportNameChanged($event)"
                                    ariaLabel="Reports.sharedReportSetupDialog.report.name.placeholder"
                                ></agpr-text-input>
                                <agpr-form-message *ngIf="nameEmpty">
                                    {{ 'Reports.sharedReportSetupDialog.report.name.required' | localize}}
                                </agpr-form-message>
                                <agpr-form-message *ngIf="duplicateName">
                                    {{ 'Reports.sharedReportSetupDialog.report.name.duplicated' | localize}}
                                </agpr-form-message>
                            </div>
                        </agpr-panel>
                        <div class="agpr-createSharedReport-form-coverPageContent">
                            <agpr-panel
                                class="agpr-createSharedReport-form-title"
                                [header]="'Reports.sharedReportSetupDialog.report.title'"
                                [toggleable]="false"
                                [contentPadding]="false"
                                [paddingBottom]="0"
                            >
                                <div class="agpr-createSharedReport-form-input">
                                    <agpr-text-input
                                        [maxLength]="64"
                                        [placeholder]="'Reports.sharedReportSetupDialog.report.title.placeholder'"
                                        [id]="'sharedReports.reportTitleTextInput'"
                                        [(ngModel)]="sharedReport.coverTitle"
                                        (ngModelChange)="reportTitleChanged($event)"
                                        ariaLabel="Reports.sharedReportSetupDialog.report.title.placeholder"
                                    ></agpr-text-input>
                                    <agpr-form-message *ngIf="titleEmpty">
                                        {{ 'Reports.sharedReportSetupDialog.report.title.required' | localize}}
                                    </agpr-form-message>
                                </div>
                            </agpr-panel>
                            <div class="agpr-createSharedReport-form-image">
                                <agpr-file-upload #fileUpload
                                    id="sharedReports.imageUpload"
                                    header="Reports.sharedReportSetupDialog.report.coverPageImage.header"
                                    placeholder="Reports.sharedReportSetupDialog.report.coverPageImage.placeholder"
                                    [holdFileData]="true"
                                    uploadButtonLabel=""
                                    [useContentLibraryUpload]="true"
                                    [uploadButtonIcon]="'fa-regular fa-square-plus'"
                                    [supportedFileTypesRegex]="imageMIMETypesRegex"
                                    [supportedFileTypes]="imageMIMETypes"
                                    [maxFiles]="1"
                                    [(ngModel)]="coverImage"
                                    (uploadButtonClick)="openContentLibrary()"
                                ></agpr-file-upload>
                            </div>
                        </div>
                    </div>
                    <div
                        class="agpr-createSharedReport-dateFormat"
                    >
                        <agpr-dropdown
                            [id]="'sharedReports_dateFormat'"
                            [label]="'Reports.sharedReportSetupDialog.report.dateFormat'"
                            [options]="dateFormatOptions"
                            [bindToValue]="true"
                            [(ngModel)]="sharedReport.dateFormat"
                        ></agpr-dropdown>
                    </div>
                </div>

            </agpr-panel>

            <div class="agpr-createSharedReport-chartsSelection">
                <agpr-panel
                    [header]="'Reports.sharedReportSetupDialog.charts.selection'"
                    [toggleable]="false"
                    [contentPadding]="false"
                ></agpr-panel>
                <!-- Chart List -->
                <div class="agpr-createSharedReport-chartList">
                    <ul
                        id="createSharedReports_chartList"
                        agprListKeyboardNavigation
                        [list]="charts"
                    >
                        <li
                            class="agpr-createSharedReport-chartList-chart"
                            *ngFor="let chart of charts; index as i"
                            [attr.aria-label]="chart.displayElement?.title | localize"
                        >
                            <div class="agpr-createSharedReport-chartList-chart-inner agpr-contextMenu-parent">
                                <span class="agpr-createSharedReport-chartList-chart-checkbox">
                                    <agpr-checkbox
                                        [id]="'createSharedReports_chartList' + '_checkbox_' + i"
                                        [value]="chart"
                                        [(ngModel)]="sharedReport.charts"
                                        (onChange)="enableEditingNote($event, chart)"
                                        [disabled]="prominenceStatus !== prominenceStatuses.DONE
                                            && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH)"
                                        [pTooltip]="((prominenceStatus !== prominenceStatuses.DONE && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH))
                                            ? 'Reports.sharedReportSetupDialog.charts.disabled.tooltop' : '') | localize"
                                    ></agpr-checkbox>
                                </span>
                                <div class="agpr-createSharedReport-chartList-chart-chartCard">
                                    <agpr-chart-card
                                        [id]="'createSharedReports_chartList' + '_chartCard_' + i"
                                        [chart]="chart"
                                        [dateFormat]="sharedReport.dateFormat"
                                        (click)="setActiveChart(chart)"
                                        [selected]="activeChart && activeChart.displayElement.index == chart.displayElement.index"
                                    ></agpr-chart-card>
                                    <div class="agpr-contextMenu top right">
                                    <agpr-button
                                        *ngIf="i != 0"
                                        icon="fa-regular fa-arrow-up"
                                        (click)="moveChartUp(i)"
                                        [style]="buttonTypes.contextMenu"
                                        tooltip="Reports.sharedReportSetupDialog.charts.moveUp"
                                        tooltipPosition="top"
                                    ></agpr-button>
                                    <agpr-button
                                        *ngIf="i != charts.length - 1"
                                        icon="fa-regular fa-arrow-down"
                                        (click)="moveChartDown(i)"
                                        [style]="buttonTypes.contextMenu"
                                        tooltip="Reports.sharedReportSetupDialog.charts.moveDown"
                                        tooltipPosition="top"
                                    ></agpr-button>
                                </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="sharedReportCreateDialog.cancelButton"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="sharedReportCreateDialog.nextStep"
            [label]="sharedReport.id ? 'Reports.sharedReportEditDialog.update' : 'Reports.sharedReportSetupDialog.heading'"
            [style]="buttonTypes.primary"
            [loading]="saveLoading"
            [disabled]="sharedReport.charts.length === 0 || duplicateName || titleEmpty || nameEmpty"
            (click)="sharedReport.id ? updateSharedReport() : createSharedReport()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>

